import { useLanguage } from "../../../i18n/LanguageContext";

export default function MuscleBlock({ block }) {
  const { language } = useLanguage();

  const c = block.content || {};
  const translated = block.translated_content || {};

  const getTranslation = (chineseValue, translatedValue) => {
    if (language === "zh") {
      return chineseValue || null;
    }

    if (language === "es" || language === "ru") {
      return translatedValue || null;
    }

    return null;
  };

  const nameTranslation = getTranslation(
    c.name_zh,
    translated.name
  );

  const rows = [
    [
      "Origin",
      c.origin_en,
      getTranslation(c.origin_zh, translated.origin),
    ],
    [
      "Insertion",
      c.insertion_en,
      getTranslation(c.insertion_zh, translated.insertion),
    ],
    [
      "Action",
      c.action_en,
      getTranslation(c.action_zh, translated.action),
    ],
    [
      "Synergist",
      c.synergist_en,
      getTranslation(c.synergist_zh, translated.synergist),
    ],
    [
      "Antagonist",
      c.antagonist_en,
      getTranslation(c.antagonist_zh, translated.antagonist),
    ],
  ];

  const descriptionTranslation = getTranslation(
    c.description_zh,
    translated.description
  );

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {/* Canonical English name */}
      <h3 style={{ margin: 0 }}>
        {c.name_en}
      </h3>

      {/* Selected-language name */}
      {nameTranslation && (
        <div
          style={{
            color: "#6b7280",
            marginTop: "4px",
            marginBottom: "18px",
          }}
        >
          {nameTranslation}
        </div>
      )}

      {rows.map(([label, english, translation]) => {
        if (!english && !translation) return null;

        return (
          <div
            key={label}
            style={{
              padding: "12px 0",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <strong>{label}</strong>

            {/* Canonical English */}
            {english && (
              <div style={{ marginTop: "5px" }}>
                {english}
              </div>
            )}

            {/* Selected-language learning aid */}
            {translation && (
              <div
                style={{
                  marginTop: "4px",
                  color: "#6b7280",
                }}
              >
                {translation}
              </div>
            )}
          </div>
        );
      })}

      {(c.description_en || descriptionTranslation) && (
        <div
          style={{
            paddingTop: "14px",
            borderTop: "1px solid #e5e7eb",
          }}
        >
          <strong>Key Information</strong>

          {/* Canonical English */}
          {c.description_en && (
            <div
              style={{
                marginTop: "6px",
                lineHeight: "1.65",
              }}
            >
              {c.description_en}
            </div>
          )}

          {/* Selected-language learning aid */}
          {descriptionTranslation && (
            <div
              style={{
                marginTop: "6px",
                color: "#6b7280",
                lineHeight: "1.65",
              }}
            >
              {descriptionTranslation}
            </div>
          )}
        </div>
      )}
    </div>
  );
}